import { Api } from "../Api";

export const carregaCobrancas = async (e) => {
  const { provider_id, user_id, limit, page } = e;
  const { data } = await Api.get(`/cobranca/generica/${provider_id}/${user_id}/${limit}/${page}`, { timeout: 500000 });
  return data;
};

export const carregaCobrancasTodas = async (e) => {
  const { provider_id, user_id } = e;
  const { data } = await Api.get(`/cobranca/lista-leve/${provider_id}/${user_id}`, { timeout: 500000 });
  return data;
};

export const carregaNegociadas = async (e) => {
  const { user_id, provider_id } = e;
  const { data } = await Api.get(`genericnegotiation/list/${user_id}/${provider_id}`);
  return data;
};

export const carregaDesconto = async (pcc_id) => {
  const { data } = await Api.get(`cobranca/cliente-valores-desconto/${pcc_id}`);
  return data;
};

export const carregaProtestadas = async (e) => {
  const { usuario_documento, provider_id } = e;
  const { data } = await Api.post(`protesto/buscaCobrancas`, {
    usuario_documento,
    usuario_id: provider_id,
  });
  return data;
};

export const carregaNotificacao = async (e) => {
  const { provider_id } = e;
  const { data } = await Api.post(`/notificacao/buscarNotificacao`, {
    provider_id: provider_id,
  });

  // CORREÇÃO: Verificar se há notificações válidas
  if (data && data.items && data.items.length > 0) {
    return data.items; // Retorna apenas o array de items
  } else if (Array.isArray(data) && data.length > 0) {
    return data;
  } else {
    return []; // Sempre retorna array, mesmo vazio
  }
};

export const carregaQuebradas = async (cobranca_id, signal = "") => {
  const options = signal === "" ? {} : { signal };

  const { data } = await Api.get(`cobranca/quebrada/${cobranca_id}`, options);
  return data;
};

export const carregaNegociacaoCobrancas = async (negociacao_id) => {
  const { data } = await Api.get(`cobranca/consulta-cobrancas-negociadas/${negociacao_id}`);
  return data;
};

export const consultaNegociavelAvenida = async (user_id) => {
  const { data } = await Api.get(`cobranca/dividaStatusAvenida/${user_id}`);
  return data;
};
